


























import { Component, Vue, Prop, Emit, Ref } from 'vue-property-decorator';
import ProductEdit from '@/components/Product/ProductEdit.vue';
import SPopup from '@/components/UI/Popup/SPopup.vue';

@Component({
  components: {
    ProductEdit,
  },
})
export default class ProductEditButton extends Vue {
  @Prop(String) public id!: string;
  @Ref() public parentPopup?: SPopup
  public showDialog = false;

  @Emit()
  public productUpdated() {
    this.showDialog = false;
  }
}
